<app-admin-header></app-admin-header>

<div class="stock-container">
  <app-admin-sidebar></app-admin-sidebar>

  <!-- 🔹 Header Bar -->
  <div class="header-bar">
    <h2>🧪 Stock Items</h2>
    <button class="open-modal-btn" (click)="showStockModal = true">➕ Add Item</button>
  </div>

  <!-- 🔍 Toolbar -->
  <div class="toolbar">
    <input
      type="text"
      [(ngModel)]="search"
      placeholder="Search by name..."
      class="search-input"
    />

    <button (click)="exportToCSV()">📤 Export CSV</button>

    <label class="upload-btn">
      📥 Import Excel
      <input type="file" (change)="importFromExcel($event)" accept=".xlsx, .xls" hidden />
    </label>
  </div>

  <!-- 🧪 Advanced Filters -->
  <div class="filters">
    <select [(ngModel)]="filterCategory">
      <option value="">All Categories</option>
      <option *ngFor="let cat of uniqueCategories" [value]="cat">{{ cat }}</option>
    </select>

    <input type="text" [(ngModel)]="filterUnit" placeholder="Filter by Unit..." />
    <input type="number" [(ngModel)]="filterMin" placeholder="Min Stock Level ≥ ..." />
    <input type="number" [(ngModel)]="filterQty" placeholder="Quantity ≥ ..." />

    <select [(ngModel)]="filterExpiryMonth">
      <option value="">All Expiry Months</option>
      <option *ngFor="let m of monthList" [value]="m.value">{{ m.name }}</option>
    </select>

    <button (click)="clearFilters()">🧹 Clear Filters</button>
  </div>

  <!-- ✅ Feedback Toast -->
  <div *ngIf="feedbackMessage" [ngClass]="feedbackType" class="toast">
    {{ feedbackMessage }}
  </div>

  <!-- 📋 Stock Item Table -->
  <table class="stock-table">
    <thead>
      <tr>
        <th (click)="sortBy('name')">Name</th>
        <th (click)="sortBy('category')">Category</th>
        <th>Unit</th>
        <th (click)="sortBy('cost_price')">Cost</th>
        <th (click)="sortBy('selling_price')">Selling</th>
        <th (click)="sortBy('min_stock_level')">Min</th>
        <th (click)="sortBy('quantity')">Qty</th>
        <th (click)="sortBy('expiry_date')">Expiry</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of paginatedItems"
        [ngClass]="{ 'low-stock': isLowStock(item), 'near-expiry': isNearExpiry(item) }"
      >
        <td><span class="label">Name:</span> <span class="value">{{ item.name }}</span></td>
        <td><span class="label">Category:</span> <span class="value">{{ item.category }}</span></td>
        <td><span class="label">Unit:</span> <span class="value">{{ item.unit }}</span></td>
        <td><span class="label">Cost:</span> <span class="value">{{ item.cost_price }}</span></td>
        <td><span class="label">Selling:</span> <span class="value">{{ item.selling_price }}</span></td>
        <td><span class="label">Min:</span> <span class="value">{{ item.min_stock_level }}</span></td>
        <td><span class="label">Qty:</span> <span class="value">{{ item.quantity }}</span></td>
        <td><span class="label">Expiry:</span> <span class="value">{{ item.expiry_date | date }}</span></td>
        <td class="actions">
          <button (click)="edit(item)">✏️</button>
          <button (click)="delete(item.id)">🗑️</button>
          <button (click)="selectedRestockItem = item; restockModalOpen = true">🔄</button>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- 🔄 Pagination -->
  <div class="pagination">
    <button (click)="page = page - 1" [disabled]="page === 1">⬅️ Prev</button>
    <span>Page {{ page }} of {{ totalPages() }}</span>
    <button (click)="page = page + 1" [disabled]="page === totalPages()">Next ➡️</button>
  </div>

  <!-- ➕ Add/Edit Modal -->
  <div class="modal-backdrop" *ngIf="showStockModal">
    <div class="modal">
      <h3>{{ editingItem ? '✏️ Edit Item' : '➕ Add New Item' }}</h3>
      <form (ngSubmit)="saveItem()" class="modal-form">

        <label for="name">Name:</label>
        <input type="text" id="name" [(ngModel)]="newItem.name" name="name" required />

        <select
        id="category"
        [(ngModel)]="newItem.category"
        name="category"
        (change)="onCategoryChange($event)"
        required
      >
        <option value="" disabled>Select Category</option>
        <option *ngFor="let c of categories" [value]="c">{{ c }}</option>
        <option value="__new__">➕ Add New Category</option>
      </select>


        <div *ngIf="addingCategory" class="new-category-field">
          <label for="newCat">New Category:</label>
          <input
            id="newCat"
            type="text"
            [(ngModel)]="newCategoryName"
            placeholder="Type new category..."
            name="newCat"
            required
          />
        </div>

        <label for="unit">Unit (e.g. mg):</label>
        <input type="text" id="unit" [(ngModel)]="newItem.unit" name="unit" required />

        <label for="cost_price">Cost Price:</label>
        <input type="number" id="cost_price" [(ngModel)]="newItem.cost_price" name="cost_price" required />

        <label for="selling_price">Selling Price:</label>
        <input type="number" id="selling_price" [(ngModel)]="newItem.selling_price" name="selling_price" required />

        <label for="min_stock_level">Min Stock Level:</label>
        <input type="number" id="min_stock_level" [(ngModel)]="newItem.min_stock_level" name="min_stock_level" required />

        <label for="quantity">Quantity:</label>
        <input type="number" id="quantity" [(ngModel)]="newItem.quantity" name="quantity" required />

        <label for="expiry_date">Expiry Date:</label>
        <input type="date" id="expiry_date" [(ngModel)]="newItem.expiry_date" name="expiry_date" required />

        <div class="modal-actions">
          <button type="submit">{{ editingItem ? 'Update' : 'Add' }}</button>
          <button type="button" class="cancel" (click)="resetForm(); showStockModal = false;">Cancel</button>
        </div>
      </form>
    </div>
  </div>

  <!-- 🔄 Restock Modal -->
<div class="modal-backdrop" *ngIf="restockModalOpen && selectedRestockItem">
  <div class="modal">
    <h3>🔄 Restock {{ selectedRestockItem.name }}</h3>
    <form (ngSubmit)="restockItem()" class="modal-form">
      <label for="restockAmount">Add Quantity:</label>
      <input
        type="number"
        [(ngModel)]="restockAmount"
        name="restockAmount"
        id="restockAmount"
        required
        min="1"
      />

      <div class="modal-actions">
        <button type="submit">✅ Confirm Restock</button>
        <button type="button" class="cancel" (click)="restockModalOpen = false; restockAmount = 0;">
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>

</div>
